export default __webpack_public_path__ + "static/media/image12tum.94890c88.jpg";